import generateSignUpUrl from "view/apps/Organiser/pages/Settings/EmbeddedShowList/components/ShowCard/LinkButton/helpers";
import { useOrganiserCompany } from "store/organiser-company/organiser-company.store";
import { useEffect } from "react";

export const generateRedirectPath = async (showId: string) => {
  const {
    fetchOneByShowId,
    selected: organiserCompany,
    isLoading,
  } = useOrganiserCompany();

  useEffect(() => {
    if (showId) {
      fetchOneByShowId({
        showId,
      });
    }
  }, [showId]);

  if (!organiserCompany || isLoading) {
    return "";
  }

  const {
    isShowListAllowed,
    embeddedShow: { shows, isEnabled, token } = {},
  } = organiserCompany;

  const isExistShow = shows?.find((show) => show?.id === showId);

  const isShowEmbedded = isShowListAllowed && isEnabled && isExistShow && token;

  if (!isShowEmbedded) {
    return "";
  }

  return generateSignUpUrl(showId, token);
};
